module.exports = __webpack_public_path__ + "img/logo.1ea2fb31.jpg";